import { UserOutlined } from '@ant-design/icons';
import { ConfigProvider, Form, Input, Modal } from 'antd';
import { useEffect } from 'react';

const GuestInfoModal = ({ isOpen, onSubmit, onCancel, initialValues }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (isOpen) {
      if (initialValues) {
        form.setFieldsValue(initialValues);
      } else {
        form.resetFields();
      }
    }
  }, [isOpen, form, initialValues]);

  const handleCancel = () => {
    if (onCancel) {
      onCancel();
    }
  };

  const handleConfirm = () => {
    form.validateFields().then((values) => {
      onSubmit(values);
    });
  };

  return (
    <Modal
      open={isOpen}
      onCancel={handleCancel}
      footer={null}
      closable={false}
      centered
      className="modern-guest-modal"
      width={560}
      zIndex={2000}
      styles={{
        body: { padding: 0 },
      }}
    >
      <div className="modern-modal-content">
        <div className="modern-modal-header">
          <div className="modern-icon-wrapper">
            <UserOutlined />
          </div>
          <div className="modern-header-text">
            <h2>Customer Details</h2>
            <p>Enter your information</p>
          </div>
        </div>

        <div className="modern-modal-body">
          <ConfigProvider
            theme={{
              token: {
                colorPrimary: '#F58220',
                borderRadius: 12,
                colorBorder: '#d1d5db',
                controlHeight: 56,
                fontSize: 18,
              },
            }}
          >
            <Form
              form={form}
              layout="vertical"
              className="modern-guest-form"
            >
              <Form.Item
                name="name"
                label="Full Name (Optional)"
                style={{ marginBottom: '20px' }}
              >
                <Input placeholder="e.g. John Doe" />
              </Form.Item>
              <Form.Item
                name="email"
                label="Email Address (Optional)"
                style={{ marginBottom: '20px' }}
                rules={[
                  { type: 'email', message: 'Please enter a valid email address!' }
                ]}
              >
                <Input type="email" placeholder="e.g. john@example.com" />
              </Form.Item>
              <Form.Item
                name="phone"
                label="Phone Number (Optional)"
                style={{ marginBottom: '0' }}
                rules={[
                  { pattern: /^[0-9]*$/, message: 'Please enter a valid phone number (digits only)!' }
                ]}
                getValueFromEvent={(e) => e.target.value.replace(/\D/g, '')}
              >
                <Input type="tel" placeholder="e.g. 07123456789" />
              </Form.Item>
            </Form>
          </ConfigProvider>
        </div>

        <div className="modern-modal-footer">
          <button
            type="button"
            className="modern-btn-cancel"
            onClick={handleCancel}
          >
            Skip
          </button>
          <button
            type="button"
            className="modern-btn-confirm"
            onClick={handleConfirm}
          >
            Continue
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default GuestInfoModal;
